import { safeLoader } from "@/lib/safe-loader";
import { seoLinks, absoluteUrl, ogImage } from "@/lib/seo";
import { createFileRoute } from "@tanstack/react-router";
import { resolveSeo, siteContentQuery } from "@/lib/site-content";
import { staffPortraitsQuery } from "@/lib/staff-portraits";

import { AboutSchoolPage } from "../../components/site/AboutSchoolPage";

export const Route = createFileRoute("/es/sobre-la-escuela")({
  loader: async ({ context }) => {
    const [data] = await Promise.all([
      safeLoader("es.about.content", () => context.queryClient.ensureQueryData(siteContentQuery), undefined),
      // Porträttdata förladdas så personalbilderna inte dyker upp sent.
      safeLoader("es.about.portraits", () => context.queryClient.ensureQueryData(staffPortraitsQuery), { portraits: {} }),
    ]);
    return { seo: resolveSeo(data?.content, "om-skolan", "es") };
  },
  head: ({ loaderData }) => {
    const title = loaderData?.seo.title ?? "";
    const description = loaderData?.seo.description ?? "";
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "article" },
        { property: "og:url", content: absoluteUrl("/es/sobre-la-escuela") },
        { name: "twitter:card", content: "summary_large_image" },
        { property: "og:locale", content: "es_ES" },
        ...ogImage(),
      ],
      links: seoLinks("/es/sobre-la-escuela"),
    };
  },
  component: AboutSchoolPage,
});
